import Resource from './Resource';

class ClientIndustry extends Resource {
	constructor() {
		super('clientIndustry');
	}

	getClientIndustryStatistics(clientId: number) {
		return this._getRequest(`statistics/${clientId}`).then(response => response.data);
	}

	getCompetitorRuleOfForty(clientId: number) {
		return this._getRequest(`competitorRuleOfForty/${clientId}`).then(response => response.data);
	}

	getKeyFigures(clientId: number) {
		return this._getRequest(`keyFigures/${clientId}`).then(response => response.data);
	}

	getMarketShareData(clientId: number) {
		return this._getRequest(`marketShareData/${clientId}`).then(response => response.data);
	}
}

export default new ClientIndustry();
